import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Product Type pages
export const ProductTypeListPage = lazy(
  () =>
    retry(() => import('@pages/settings/product-types/list')) as Promise<
      typeof import('@pages/settings/product-types/list')
    >
);

export const ProductTypeEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/product-types/edit')) as Promise<
      typeof import('@pages/settings/product-types/edit')
    >
);

export const ProductTypeCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/product-types/create')) as Promise<
      typeof import('@pages/settings/product-types/create')
    >
);

// Business Unit pages
export const BusinessUnitListPage = lazy(
  () =>
    retry(() => import('@pages/settings/business-unit/list')) as Promise<
      typeof import('@pages/settings/business-unit/list')
    >
);

export const BusinessUnitEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/business-unit/edit')) as Promise<
      typeof import('@pages/settings/business-unit/edit')
    >
);

export const BusinessUnitCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/business-unit/create')) as Promise<
      typeof import('@pages/settings/business-unit/create')
    >
);

// Business Line pages
export const BusinessLineListPage = lazy(
  () =>
    retry(() => import('@pages/settings/business-lines/list')) as Promise<
      typeof import('@pages/settings/business-lines/list')
    >
);

export const BusinessLineEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/business-lines/edit')) as Promise<
      typeof import('@pages/settings/business-lines/edit')
    >
);

export const BusinessLineCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/business-lines/create')) as Promise<
      typeof import('@pages/settings/business-lines/create')
    >
);

// Product Line pages
export const ProductLineListPage = lazy(
  () =>
    retry(() => import('@pages/settings/product-lines/list')) as Promise<
      typeof import('@pages/settings/product-lines/list')
    >
);

export const ProductLineEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/product-lines/edit')) as Promise<
      typeof import('@pages/settings/product-lines/edit')
    >
);

export const ProductLineCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/product-lines/create')) as Promise<
      typeof import('@pages/settings/product-lines/create')
    >
);

// Studio pages
export const StudioListPage = lazy(
  () =>
    retry(() => import('@pages/settings/studios/list')) as Promise<
      typeof import('@pages/settings/studios/list')
    >
);

export const StudioEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/studios/edit')) as Promise<
      typeof import('@pages/settings/studios/edit')
    >
);

export const StudioCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/studios/create')) as Promise<
      typeof import('@pages/settings/studios/create')
    >
);

// Term Condition pages
export const TermConditionListPage = lazy(
  () =>
    retry(() => import('@pages/settings/term-conditions/list')) as Promise<
      typeof import('@pages/settings/term-conditions/list')
    >
);

export const TermConditionEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/term-conditions/edit')) as Promise<
      typeof import('@pages/settings/term-conditions/edit')
    >
);

export const TermConditionCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/term-conditions/create')) as Promise<
      typeof import('@pages/settings/term-conditions/create')
    >
);

// Externality Reasons pages
export const ExternalityReasonsListPage = lazy(
  () =>
    retry(() => import('@pages/settings/externality-reasons/list')) as Promise<
      typeof import('@pages/settings/externality-reasons/list')
    >
);

export const ExternalityReasonsEditPage = lazy(
  () =>
    retry(() => import('@pages/settings/externality-reasons/edit')) as Promise<
      typeof import('@pages/settings/externality-reasons/edit')
    >
);

export const ExternalityReasonsCreatePage = lazy(
  () =>
    retry(() => import('@pages/settings/externality-reasons/create')) as Promise<
      typeof import('@pages/settings/externality-reasons/create')
    >
);
